import React, { useEffect, useState, lazy } from "react";
import { Provider, useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import store from "./redux/store";
import Admin from "./routes/admin";
import Auth from "./routes/auth";
import "./static/css/style.css";
import config from "./config/config";
import ProtectedRoute from "./components/utilities/protectedRoute";
import "antd/dist/antd.less";
import { isUserAuthorized } from "./common/Authorization";
import { UserTypes } from "./common/UserTypes";
import MicrosoftLoginPage from "./container/profile/authentication/MicrosoftLoginPage";

const NotFound = lazy(() => import("./container/pages/404"));

const { theme } = config;
function ProviderConfig() {
  const { rtl, isLoggedIn, topMenu, mainContent } = useSelector((state) => {
    return {
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      mainContent: state.ChangeLayoutMode.mode,
      isLoggedIn: state.auth.login,
      profile: state.auth.profile,
    };
  });

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }

    if (
      isUserAuthorized([
        UserTypes.AGENT_OWNER_ACCOUNT_ID,
        UserTypes.AGENT_USER_ID,
      ])
    ) {
      // Select the header element
      const header = document.querySelector("header");

      // Set the background color with !important
      // Icon color     #5446FF
      header.style.setProperty("background-color", "#931B34", "important");

      // Select all elements with the specified class selector
      const elements = document.querySelectorAll(
        ".hexadash-top-menu ul li a.parent"
      );

      // Loop through each element and set its color to white
      elements.forEach((element) => {
        element.style.color = "white";
      });

      // Select the element by ID
      const usernameElement = document.getElementById("username");

      // Set the text color to white
      usernameElement.style.setProperty("color", "white", "important");
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [setPath]);

  return (
    <ConfigProvider direction={rtl ? "rtl" : "ltr"}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, mainContent }}>
        <Router basename={process.env.PUBLIC_URL}>
          {!isLoggedIn ? (
            <Routes>
              <Route path="/*" element={<Auth />} />{" "}
            </Routes>
          ) : (
            <Routes>
              <Route
                path="/admin/*"
                element={<ProtectedRoute path="/*" Component={Admin} />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          )}
          {isLoggedIn &&
            (path === process.env.PUBLIC_URL ||
              path === `${process.env.PUBLIC_URL}/`) && (
              <Routes>
                <Route path="/" element={<Navigate to="/admin" />} />
              </Routes>
            )}
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  // const isMicrosoftLoggedIn = localStorage.getItem("isMicrosoftLoggedIn");
  // if (!isMicrosoftLoggedIn) {
  //   return <MicrosoftLoginPage />;
  // }

  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default App;
